import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

function UrunDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  
  const [urun, setUrun] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Resim sırasını tutan asıl state (Bunu aktifResim yerine kullanıyoruz)
  const [seciliResimIndex, setSeciliResimIndex] = useState(0); 
  
  const sliderRef = useRef(null);

  // --- EFSANEVİ DOKUNMATİK KAYDIRMA (SWIPE) MOTORU (ARTIK İÇERİDE!) ---
  const [dokunmaBaslangic, setDokunmaBaslangic] = useState(null);
  const [dokunmaBitis, setDokunmaBitis] = useState(null);
  const minKaydirmaMesafesi = 50; 

  const dokunmaBasladi = (e) => {
    setDokunmaBitis(null);
    setDokunmaBaslangic(e.targetTouches[0].clientX);
  };

  const dokunmaHareketEtti = (e) => {
    setDokunmaBitis(e.targetTouches[0].clientX);
  };

  const dokunmaBitti = () => {
    if (!dokunmaBaslangic || !dokunmaBitis || !urun || !urun.resimler) return;
    
    const mesafe = dokunmaBaslangic - dokunmaBitis;
    const solaKaydirildi = mesafe > minKaydirmaMesafesi;
    const sagaKaydirildi = mesafe < -minKaydirmaMesafesi;
    const toplamResim = urun.resimler.length; 

    if (solaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === toplamResim - 1 ? 0 : onceki + 1));
    }
    if (sagaKaydirildi) {
      setSeciliResimIndex((onceki) => (onceki === 0 ? toplamResim - 1 : onceki - 1));
    }
  };
  // ----------------------------------------------------

  useEffect(() => {
    const urunGetir = async () => {
      try {
        const { data, error } = await supabase.from('urunler').select('*').eq('id', id).single();
        if (error) throw error;
        setUrun(data);
      } catch (error) { 
        console.error(error.message); 
      } finally { 
        setLoading(false); 
      }
    };
    urunGetir();
  }, [id]);

  const kaydir = (yon) => {
    if (sliderRef.current) {
      const miktar = 200;
      sliderRef.current.scrollBy({ left: yon === 'sol' ? -miktar : miktar, behavior: 'smooth' });
    }
  };

  const whatsappSiparis = (urunAdi) => {
    const telefon = "905305090631"; // Senin Demir Grup numaran!
    const mesaj = `Merhaba, web sitenizdeki "${urunAdi}" ürünü hakkında bilgi almak istiyorum.`;
    window.open(`https://wa.me/${telefon}?text=${encodeURIComponent(mesaj)}`, '_blank');
  };

  if (loading) return <div className="loading-spinner" style={{paddingTop: '150px'}}>Yükleniyor...</div>;
  if (!urun) return <div style={{paddingTop: '150px', textAlign: 'center', color: 'white'}}>Ürün bulunamadı!</div>;

  return (
    <div className="kamera-detay-page-new">
      <div className="detay-ust-bar">
        <button className="geri-btn" onClick={() => navigate(-1)}><span>←</span> Ürünlere Dön</button>
      </div>

      <div className="detay-container-new">
        
        {/* SOL TARAF: RESİM BÖLÜMÜ */}
        <div className="detay-image-new">
            
          {/* Ana Resim ve Dokunmatik Motor */}
          <div 
            className="ana-resim-box"
            onTouchStart={dokunmaBasladi}
            onTouchMove={dokunmaHareketEtti}
            onTouchEnd={dokunmaBitti}
          >
            {/* Eğer resim dizisi varsa seçili olanı göster */}
            {urun.resimler && urun.resimler.length > 0 && (
              <img src={urun.resimler[seciliResimIndex]} alt={`${urun.baslik} Detay`} />
            )}
          </div>

          {/* Alt Küçük Resimler (Thumbnails) */}
          <div className="thumbnails-wrapper">
            <button className="slider-btn sol" onClick={() => kaydir('sol')}>&#10094;</button>
            <div className="detay-thumbnails" ref={sliderRef}>
              {urun.resimler && urun.resimler.map((url, idx) => (
                <div 
                  key={idx} 
                  className={`thumbnail-item ${seciliResimIndex === idx ? 'active' : ''}`} 
                  onClick={() => setSeciliResimIndex(idx)}
                >
                  <img src={url} alt="thumbnail" />
                </div>
              ))}
            </div>
            <button className="slider-btn sag" onClick={() => kaydir('sag')}>&#10095;</button>
          </div>
        
        </div>

        {/* SAĞ TARAF: BİLGİ VE WHATSAPP BÖLÜMÜ */}
        <div className="detay-info-new">
          <div className="modal-header-line">Demir Grup | {urun.kategori}</div>
          <h1>{urun.baslik}</h1>
          <p className="detay-desc-new">{urun.aciklama}</p>
          
          <div className="detay-features-new">
            {urun.ozellikler && urun.ozellikler.split(',').map((o, i) => (
              <div key={i} className="feature-item-new"><span className="feature-icon">✓</span><span>{o.trim()}</span></div>
            ))}
          </div>

          <button className="whatsapp-btn-large-new" onClick={() => whatsappSiparis(urun.baslik)}>
            <span className="wa-icon">💬</span> WhatsApp'tan Bilgi Al
          </button>
          <p className="guvence-metni">🛡️ Profesyonel Malzeme ve Uzman İşçilik</p>
        </div>

      </div>
    </div>
  );
}

export default UrunDetay;